<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in bannerImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title"
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="service-content">
      <div class="service-nav">
        <a class="on" href="" target="">真伪查询</a>
        <a href="/portal_check?type=sales" target="">售后流程</a>
        <a href="/portal_check?type=question" target="">常见问题</a>
        <a href="/portal_check?type=wh" target="">使用维护</a>
      </div>
      <div class="service-box service-cx">
        <img :src="selectCodePic" alt="扫码查询">
        <p>请扫码后在手机端输入球杆编码查询真伪</p>
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  data() {
    return {
      // selectCodePic:require("@/assets/img/portal_check/select_code.png"),
      selectCodePic:'',
      bannerImgList: [],
      loading: false // 补充loading的初始化
    }
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;

        const typeStr = `${ImageTypeEnum.CHECK_30_BANNER.value},${ImageTypeEnum.CHECK_84_CODE.value}`;

        const res = await getImgList(typeStr);

        const dataList = res.data || [];
        this.bannerImgList = dataList.filter(item => item.classify === ImageTypeEnum.CHECK_30_BANNER.value && item.src);
        this.selectCodePic = dataList.filter(item => item.classify === ImageTypeEnum.CHECK_84_CODE.value && item.src)[0].src;
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，避免大屏拉伸
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 15px; // 移动端增加左右内边距，防止内容贴边
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板适配 (768px以下)
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  // 手机适配 (480px以下)
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 880px !important;

  // 平板适配
  @media (max-width: 768px) {
    height: 400px !important; // 调整高度，更符合平板显示
  }
  // 手机适配（使用vw单位，适配不同屏幕宽度）
  @media (max-width: 480px) {
    height: 50vw !important;
    max-height: 300px; // 限制最大高度，避免小屏过高
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  // 移动端优化图片显示
  @media (max-width: 480px) {
    object-fit: contain;
    background: #f5f5f5;
  }
}

.service-nav {
  text-align: center;
  background: #fff;
  padding: 0 10px; // 增加内边距，防止按钮贴边

  // 平板适配
  @media (max-width: 768px) {
    padding: 0 5px;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 0;
  }

  a, span {
    color: #222;
    display: inline-block;
    vertical-align: top;
    width: 12%;
    height: 50px;
    margin: 50px 1%;
    text-align: center;
    line-height: 48px;
    font-size: 18px;
    border: 1px solid #666;
    cursor: pointer;
    border-radius: 6px;
    box-sizing: border-box; // 确保边框不影响宽度
    text-decoration: none; // 去除链接下划线

    // 平板适配
    @media (max-width: 768px) {
      width: 22%; // 调整宽度，适配平板
      margin: 30px 1%;
      height: 45px;
      line-height: 43px;
      font-size: 16px;
    }

    // 手机适配
    @media (max-width: 480px) {
      width: 46%; // 改为两行显示
      margin: 15px 2%;
      height: 40px;
      line-height: 38px;
      font-size: 14px;
    }
  }

  .on {
    background: #d26b6b;
    color: #fff;
    border-color: #d26b6b;
  }
}

.service-nav-fixed {
  z-index: 666;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: none;
  box-shadow: 0 0 8px rgba(0,0,0,.1);
  padding: 0 10px; // 增加内边距

  a, span {
    height: 36px;
    line-height: 36px;
    margin: 15px 1%;
    font-size: 16px;

    // 手机适配
    @media (max-width: 480px) {
      height: 32px;
      line-height: 30px;
      margin: 10px 2%;
      font-size: 13px;
    }
  }
}

.service-box {
  padding: 50px 0;
  background: #f6f6f6;

  // 平板适配
  @media (max-width: 768px) {
    padding: 30px 0;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 20px 0;
  }
}

.service-cx {
  text-align: center;

  img {
    width: 10%;
    margin: 0 auto;
    max-height: 100%;
    max-width: 100%;
    display: block;
    border: none;

    // 平板适配
    @media (max-width: 768px) {
      width: 20%; // 放大二维码，方便扫码
    }

    // 手机适配
    @media (max-width: 480px) {
      width: 50%; // 进一步放大二维码
      max-width: 200px; // 限制最大宽度
    }
  }

  p {
    margin: 70px 0 0 0;
    font-size: 24px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1px;
    padding: 0 20px; // 增加左右内边距，防止文字溢出

    // 平板适配
    @media (max-width: 768px) {
      margin-top: 40px;
      font-size: 20px;
      line-height: 35px;
    }

    // 手机适配
    @media (max-width: 480px) {
      margin-top: 20px;
      font-size: 16px;
      line-height: 28px;
      letter-spacing: 0.5px;
    }
  }
}
</style>